import { Injectable } from '@angular/core';
import { Observable, delay, of } from 'rxjs';
import { NavigationItem } from '@shared/models/navigation-item.model';
import { environment } from '@env/environment';

export interface AppShellConfig {
  readonly appName: string;
  readonly tagline: string;
  readonly apiBaseUrl: string;
  readonly navigation: readonly NavigationItem[];
}

@Injectable({
  providedIn: 'root',
})
export class AppConfigApiService {
  private readonly shellConfig: AppShellConfig = {
    appName: 'Veredis AI App',
    tagline: 'Angular 21 enterprise starter',
    apiBaseUrl: environment.apiBaseUrl,
    navigation: [
      {
        label: 'Dashboard',
        route: '/dashboard',
        description: 'Area protegida para operacoes, metricas e jornadas autenticadas.',
      },
      {
        label: 'Home',
        route: '/home',
        description: 'Landing interna publica para apresentar a arquitetura das features.',
      },
    ],
  };

  getShellConfig(): Observable<AppShellConfig> {
    return of(this.shellConfig).pipe(delay(100));
  }

  getApiBaseUrl(): string {
    return this.shellConfig.apiBaseUrl;
  }
}
